import { useEffect, useRef, useState } from 'react';
import { Animated, Easing } from 'react-native';

export function CountUp({ value, delay = 420 }: { value: number; delay?: number }) {
  const anim = useRef(new Animated.Value(0)).current;
  const [displayed, setDisplayed] = useState(0);

  useEffect(() => {
    anim.setValue(0);
    setDisplayed(0);
    const listenerId = anim.addListener(({ value: v }) => setDisplayed(Math.round(v)));
    const timer = setTimeout(() => {
      Animated.timing(anim, {
        toValue: value,
        duration: 700,
        easing: Easing.out(Easing.cubic),
        useNativeDriver: false,
      }).start();
    }, delay);
    return () => {
      clearTimeout(timer);
      anim.removeListener(listenerId);
      anim.stopAnimation();
    };
  }, [value, delay, anim]);

  return <>{displayed}</>;
}
